(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["korner-option-states"] && !Shopify.designMode) return;
  try {
    (()=>{
 const init=()=>{
  document.querySelectorAll('.product-section').forEach(section=>{
   if(section.dataset.kornerOptions)return;
   const source=section.querySelector('[data-product-json]');
   const meta=section.querySelector('[data-variant-metafields]');
   const labels=document.querySelector('[data-korner-option-labels]');
   if(!source||!meta||!labels)return;
   section.dataset.kornerOptions='true';
   const product=JSON.parse(source.textContent),states=JSON.parse(meta.textContent);
   const update=()=>{
    const chosen=Array.from(section.querySelectorAll('.product__form .single-option-selector')).map(input=>({key:input.dataset.index,value:input.value}));
    section.querySelectorAll('.product__form [data-swatch-wrapper]').forEach(wrapper=>{
     const key=wrapper.dataset.index;
     wrapper.querySelectorAll('[data-swatch-link]').forEach(link=>{
      const value=link.dataset.value;
      const variant=product.variants.find(v=>v[key]===value&&chosen.every(option=>option.key===key||v[option.key]===option.value));
      const preorder=variant?.available&&states[variant.id]?.overselling===true;
      const status=!variant?labels.dataset.unavailable:!variant.available?labels.dataset.soldout:preorder?labels.dataset.preorder:'';
      const item=link.closest('[data-swatch-item]');
      item.classList.toggle('soldout',!variant?.available);item.classList.toggle('overselling',!!preorder);
      const current=chosen.some(option=>option.key===key&&option.value===value);
      if(current)link.setAttribute('aria-current','true');else link.removeAttribute('aria-current');
      link.setAttribute('aria-label',value+(status?' · '+status:''));
      const badge=link.querySelector('.korner-option-status');if(badge)badge.textContent=status;
      if(variant){const url=new URL(link.href,location.origin);url.searchParams.set('variant',String(variant.id));link.href=url.pathname+url.search;}
     });
    });
   };
   update();section.addEventListener('variant:changed',update);
  });
 };
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
 document.addEventListener('shopify:section:load',init);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["korner-product-ui-labels"] && !Shopify.designMode) return;
  try {
    (()=>{const init=()=>{const config=document.querySelector('[data-korner-ui-labels]');if(!config)return;
 const translate=(root,pattern,label)=>{const walk=document.createTreeWalker(root,NodeFilter.SHOW_TEXT);let node;while((node=walk.nextNode())){if(/^(SCRIPT|STYLE)$/.test(node.parentElement.tagName))continue;if(pattern.test(node.textContent.trim())&&node.textContent!==label)node.textContent=label;}};
 document.querySelectorAll('[data-korner-size-label],.product__colors').forEach(root=>{if(root.dataset.labelBound)return;root.dataset.labelBound='true';const update=()=>root.hasAttribute('data-korner-size-label')?translate(root,/^Size (?:Chart|Guide)$/i,root.dataset.kornerSizeLabel):translate(root,/^Colou?rs?\s*:?$/i,config.dataset.color+'：');update();new MutationObserver(update).observe(root,{childList:true,subtree:true});});
document.querySelectorAll('.product__form form').forEach(form=>{if(form.dataset.kornerLabels)return;form.dataset.kornerLabels='true';const update=()=>{form.querySelectorAll('.webyzeProductColorsLabel').forEach(label=>{if(label.textContent!==config.dataset.color)label.textContent=config.dataset.color;});form.querySelectorAll('[data-korner-size-label] [aria-label="link to open Size Chart Modal"]').forEach(button=>button.setAttribute('aria-label',button.closest('[data-korner-size-label]').dataset.kornerSizeLabel));};update();new MutationObserver(update).observe(form,{childList:true,subtree:true});});
const floats=root=>{if(root.nodeType!==1)return;const nodes=root.matches('.ks-chart-float-button')?[root]:root.querySelectorAll('.ks-chart-float-button');nodes.forEach(button=>{translate(button,/^Size (?:Chart|Guide)$/i,config.dataset.size);button.setAttribute('aria-label',config.dataset.size);});};floats(document.body);new MutationObserver(records=>records.forEach(record=>record.addedNodes.forEach(floats))).observe(document.body,{childList:true,subtree:true});
};if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();document.addEventListener('shopify:section:load',init);})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["korner-soldout-recovery"] && !Shopify.designMode) return;
  try {
    (() => {
  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const data = JSON.parse(root.querySelector('[data-kr-data]').textContent);
    const section = document.getElementById('shopify-section-' + root.dataset.sectionId);
    if (!section) return;
    const form = section.querySelector('[data-product-form]');
    const cards = root.querySelector('[data-kr-cards]');
    const alternatives = root.querySelector('[data-kr-alternatives]');
    const browse = root.querySelector('[data-kr-browse]');
    const whatsapp = root.querySelector('[data-kr-whatsapp]');
    const templates = [...root.querySelectorAll('template[data-size]')];
    const preview = new URL(location.href).searchParams.get('preview_theme_id');
    function render(id) {
      const variant = data.variants[String(id)];
      root.hidden = !variant || variant.available || root.dataset.enabled === 'false';
      if (!variant) return;
      if (root.hidden) return;
      cards.replaceChildren();
      const used = new Set();
      templates.filter(template => variant.size && template.dataset.size === variant.size).forEach(template => {
        if (used.has(template.dataset.product)) return;
        used.add(template.dataset.product);
        cards.append(template.content.cloneNode(true));
      });
      alternatives.hidden = !cards.childElementCount;
      browse.hidden = !variant.size || !root.dataset.collectionUrl;
      if (!browse.hidden) {
        const url = new URL(root.dataset.collectionUrl, location.origin);
        url.searchParams.set('kf', '1');
        url.searchParams.set('kf_stock', '1');
        url.searchParams.set('kf_size', variant.size);
        if (root.dataset.productType) url.searchParams.set('kf_type', root.dataset.productType);
        if (preview) url.searchParams.set('preview_theme_id', preview);
        browse.href = url.href;
        browse.textContent = data.browse.replace('__SIZE__', variant.size);
      }
      if (preview) cards.querySelectorAll('a[href]').forEach(link => {
        const url = new URL(link.href); url.searchParams.set('preview_theme_id', preview); link.href = url.href;
      });
      if (whatsapp) {
        const url = new URL('https://api.whatsapp.com/send');
        url.searchParams.set('phone', root.dataset.phone);
        url.searchParams.set('text', variant.message);
        whatsapp.href = url.href;
      }
    }
    section.addEventListener('variant:changed', event => render(event.detail?.variant?.id));
    form?.addEventListener('change', event => { if (event.target.name === 'id') render(event.target.value); });
    render(root.dataset.initialVariant);
  }
  function start(context = document) { context.querySelectorAll('[data-korner-recovery]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => start(), {once:true});
  else start();
  document.addEventListener('shopify:section:load', event => start(event.target));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["low-stock-urgency"] && !Shopify.designMode) return;
  try {
    (()=>{const init=()=>{const widget=document.getElementById('korner-stock-widget');const source=document.getElementById('korner-variant-data');if(!widget||!source||widget.dataset.bound)return;widget.dataset.bound='true';const variants=JSON.parse(source.textContent);const notice=document.getElementById('korner-dispatch-notice');const section=widget.closest('[data-section-id]');
const update=id=>{const state=variants[String(id)];widget.querySelector('[data-ksw-label]').textContent=state?.status||'';if(notice){notice.querySelector('[data-korner-dispatch-text]').textContent=state?.dispatch||'';notice.hidden=!state?.dispatch;}};
document.addEventListener('variant:changed',event=>{if(!widget.isConnected)return;if(event.target!==document&&section&&!section.contains(event.target))return;update(event.detail?.variant?.id);});update(widget.dataset.initVariant);};if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();document.addEventListener('shopify:section:load',init);})();
  } catch(e) { console.error(e); }
})();

})();
